import React from 'react';
import { siteConfig } from '../config/siteConfig';
import '../styles/AboutSection.css';

const AboutSection = () => {
  const { company } = siteConfig;

  return (
    <section className="about-section" id="about">
      <div className="container">
        <div className="section-header-modern">
          <h2 className="section-title-main">About Us</h2>
        </div>

        <div className="about-card">
          <h3>{company.name}</h3>
          <p>{company.about}</p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
